import React, { useState } from "react";
import PropTypes from "prop-types";
import { scrollIntoView } from "utils/helper";
import QualificationsInformation from "./qualificationsInformation";
import EditQualificationsInformation from "./editQualificationsInformation";
import UseQualificationsInformation from "./useQualificationsInformation";

function Index({ isShowEditIcon }) {
  const [isEditMode, setIsEditMode] = useState(false);
  const { isQualificationsLoading, onEditQualifications } =
    UseQualificationsInformation();

  const handleEditClick = () => {
    setIsEditMode(true);
  };

  const handleDiscard = () => {
    setIsEditMode(false);
    scrollIntoView("personalDetailsScrollId");
  };

  const handleSave = async (values) => {
    await onEditQualifications(values);
    setIsEditMode(false);
  };

  if (isEditMode) {
    return (
      <EditQualificationsInformation
        onDiscard={handleDiscard}
        onSave={handleSave}
        isLoading={isQualificationsLoading}
      />
    );
  }

  return (
    <QualificationsInformation
      onEditClick={handleEditClick}
      isShowEditIcon={isShowEditIcon}
    />
  );
}

export default Index;
Index.propTypes = {
  isShowEditIcon: PropTypes.bool,
};
